// extracted by mini-css-extract-plugin
module.exports = {"form":"FormInput_form__KhE9i","input":"FormInput_input__vUsh3"};